import { HttpMonitor } from './../../../../libs/core/src/lib/utils/http.monitor';
import { SpinnerService } from 'libs/core/src/lib/services/spinner.service';
import { LoadingService } from 'libs/core/src/lib/services/loading.service';
import { AfterViewInit, Component, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { PreLoaderService } from 'libs/core/src/lib/services/pre-loader.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'concourse-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit, AfterViewChecked {
  title = 'resource-portal';
  showLoader = false;
  constructor(
    private _spinnerService: SpinnerService,
    private _loadingService: LoadingService,
    public httpMonitor: HttpMonitor,
    private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    if(environment.production && localStorage.getItem('showLogs')){
      console.log = ()=>{}
    }
    this.initializeLoader();
  }
  initializeLoader() {
    this._loadingService.showLoader.subscribe(async (value) => {
      this.showLoader = await value;
    });
  }
  ngAfterViewInit(): void {
    PreLoaderService.load().then(() => {
      this._spinnerService.hide(1000);
    });
  }
  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
}
